import { createSelector } from 'reselect';

import getCartItems from './getCartItems';

const getCartItemsCount = createSelector(
  getCartItems,
  cartItems => cartItems.reduce((total, item) => total + item.quantity, 0),
);

export default getCartItemsCount;
